module.exports = __webpack_public_path__ + "img/product-smoke-4.97b9cf82.jpg";